module.exports = __webpack_public_path__ + "img/CH6.656e8fa9.jpg";